import { BulkActionsVariant, BulkEntityActionItem } from "components/BulkActions/types";

import { UserRolesMutationVariables } from "./useUserRolesBulkActions/types";
import { UserViewBinding } from "../../types";

export enum UserRolesBulkActions {
  Delete = "Delete",
}

export type UserRolesBulkActionsAnalyticsPayload = {
  view: BulkActionsVariant;
  metadata: Record<string, string | boolean>;
};

export type UserRolesBulkActionsSelectedAction = BulkEntityActionItem<
  UserRolesBulkActions,
  UserViewBinding,
  UserRolesMutationVariables
>;
